import { render, staticRenderFns } from "./visitors-total-number.vue?vue&type=template&id=d789d450&scoped=true"
import script from "./visitors-total-number.vue?vue&type=script&lang=js"
export * from "./visitors-total-number.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d789d450",
  null
  
)

export default component.exports